import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle } from '../../../utils/utils';
import CBInputField from '../../shared/form_components/CBInputField';
import CBLabelAndCheckbox from '../../shared/CBLabelAndCheckbox';
import CBSpinnerFloating from '../../shared/CBSpinnerFloating';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import {
  fetchChainInvoiceSettings as _fetchChainInvoiceSettings,
  updateChainInvoiceSettings as _updateChainInvoiceSettings,
} from '../../../actions/chainActions';
import { T, cardStyle, inputStyle, inputLabelStyle } from './chainSettingsV2Styles';

class SettingsChainInvoiceV2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        work_hourly_surcharge: '',
        parts_markup_percentage: '',
        allow_customer_specific_margins: false,
        default_accounting_code_work: '',
        default_accounting_code_parts: '',
        default_price_list_code: '',
        default_payment_term_days: '14',
        netvisor_product_netvisor_key: '',
        netvisor_product_key_work: '',
        netvisor_product_key_parts: '',
        netvisor_product_key_other: '',
        filter_regnr_in_our_reference: false,
        filter_regnr_in_your_reference: false,
        filter_regnr_in_agreement_identifier: false,
        filter_regnr_in_item_descriptions: false,
        filter_regnr_in_attachment_free_text: false,
        filter_require_in_our_reference: '',
        filter_require_in_your_reference: '',
        filter_require_in_agreement_identifier: '',
        always_invoice_on_month_end: false,
      },
      hasChanges: false,
    };
  }

  componentDidMount() {
    var chainId = this.props.chainId;
    if (chainId) {
      this.props.fetchChainInvoiceSettings(chainId);
    }
  }

  componentDidUpdate(prevProps) {
    var settings = this.props.chainInvoiceSettings;
    var prevSettings = prevProps.chainInvoiceSettings;

    if (settings && settings !== prevSettings) {
      this.initializeForm(settings);
    }

    if (this.props.chainId && this.props.chainId !== prevProps.chainId) {
      this.props.fetchChainInvoiceSettings(this.props.chainId);
    }
  }

  initializeForm = function (settings) {
    this.setState({
      formData: {
        work_hourly_surcharge: settings.work_hourly_surcharge || '0',
        parts_markup_percentage: settings.parts_markup_percentage || '0',
        allow_customer_specific_margins: settings.allow_customer_specific_margins || false,
        default_accounting_code_work: settings.default_accounting_code_work || '',
        default_accounting_code_parts: settings.default_accounting_code_parts || '',
        default_price_list_code: settings.default_price_list_code || '',
        default_payment_term_days: settings.default_payment_term_days || '14',
        netvisor_product_netvisor_key: settings.netvisor_product_netvisor_key || '',
        netvisor_product_key_work: settings.netvisor_product_key_work || '',
        netvisor_product_key_parts: settings.netvisor_product_key_parts || '',
        netvisor_product_key_other: settings.netvisor_product_key_other || '',
        filter_regnr_in_our_reference: settings.filter_regnr_in_our_reference || false,
        filter_regnr_in_your_reference: settings.filter_regnr_in_your_reference || false,
        filter_regnr_in_agreement_identifier: settings.filter_regnr_in_agreement_identifier || false,
        filter_regnr_in_item_descriptions: settings.filter_regnr_in_item_descriptions || false,
        filter_regnr_in_attachment_free_text: settings.filter_regnr_in_attachment_free_text || false,
        filter_require_in_our_reference: settings.filter_require_in_our_reference || '',
        filter_require_in_your_reference: settings.filter_require_in_your_reference || '',
        filter_require_in_agreement_identifier: settings.filter_require_in_agreement_identifier || '',
        always_invoice_on_month_end: settings.always_invoice_on_month_end || false,
      },
      hasChanges: false,
    });
  }.bind(this);

  updateFormState = function (changedObject) {
    var formData = this.state.formData;
    this.setState({
      formData: { ...formData, [changedObject.target]: changedObject.value },
      hasChanges: true,
    });
  }.bind(this);

  submitForm = function () {
    var settings = this.props.chainInvoiceSettings;
    if (settings && settings.id) {
      this.props.updateChainInvoiceSettings(settings.id, this.state.formData);
      this.setState({ hasChanges: false });
    }
  }.bind(this);

  render() {
    var t = this.props.t;
    var settings = this.props.chainInvoiceSettings;
    var settingsStatus = this.props.chainInvoiceSettingsStatus;
    var formData = this.state.formData;
    var hasChanges = this.state.hasChanges;
    var isLoading = settingsStatus && settingsStatus.loading;

    if (!settings && isLoading) {
      return (
        <div style={{ ...cardStyle, position: 'relative', minHeight: 200 }}>
          <CBSpinnerFloating color={T.accent} />
        </div>
      );
    }

    return (
      <CBMediaQuery>
        {function (screenSize) {
          return (
            <div style={getStyle(screenSize, styles, 'card')}>
              <div style={getStyle(screenSize, styles, 'header')}>
                <div style={getStyle(screenSize, styles, 'iconBox')}>
                  <i className="pi pi-money-bill" style={{ fontSize: 20, color: T.accent }} />
                </div>
                <div>
                  <h2 style={getStyle(screenSize, styles, 'title')}>{t('invoiceSettingsTitle')}</h2>
                  <p style={getStyle(screenSize, styles, 'description')}>{t('invoiceSettingsDescription')}</p>
                </div>
              </div>

              {isLoading && <CBSpinnerFloating color={T.accent} />}

              <div style={getStyle(screenSize, styles, 'formContainer')}>
                <CBInputField
                  name="work_hourly_surcharge"
                  inputStyle={inputStyle}
                  value={formData.work_hourly_surcharge}
                  placeholder="0"
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('workHourlySurcharge')}
                  labelTextStyle={inputLabelStyle}
                  type="number"
                />

                <CBInputField
                  name="parts_markup_percentage"
                  inputStyle={inputStyle}
                  value={formData.parts_markup_percentage}
                  placeholder="0"
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('partsMarkupPercentage')}
                  labelTextStyle={inputLabelStyle}
                  type="number"
                />

                <CBInputField
                  name="default_accounting_code_work"
                  inputStyle={inputStyle}
                  value={formData.default_accounting_code_work}
                  placeholder=""
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('accountingCodeWork')}
                  labelTextStyle={inputLabelStyle}
                />

                <CBInputField
                  name="default_accounting_code_parts"
                  inputStyle={inputStyle}
                  value={formData.default_accounting_code_parts}
                  placeholder=""
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('accountingCodeParts')}
                  labelTextStyle={inputLabelStyle}
                />

                <CBInputField
                  name="default_payment_term_days"
                  inputStyle={inputStyle}
                  value={formData.default_payment_term_days}
                  placeholder="14"
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('paymentTermDays')}
                  labelTextStyle={inputLabelStyle}
                  type="number"
                />

                <div style={getStyle(screenSize, styles, 'filterSection')}>
                  <div style={getStyle(screenSize, styles, 'filterHeader')}>
                    <i className="pi pi-calendar" style={{ fontSize: 16, color: T.accent }} />
                    <h3 style={getStyle(screenSize, styles, 'filterTitle')}>{t('invoiceScheduleTitle')}</h3>
                  </div>
                  <p style={getStyle(screenSize, styles, 'filterDescription')}>{t('invoiceScheduleDescription')}</p>
                  <div style={getStyle(screenSize, styles, 'checkboxGroup')}>
                    <CBLabelAndCheckbox
                      labelText={t('alwaysInvoiceOnMonthEnd')}
                      checked={formData.always_invoice_on_month_end}
                      onChange={function () {
                        this.setState({
                          formData: { ...this.state.formData, always_invoice_on_month_end: !this.state.formData.always_invoice_on_month_end },
                          hasChanges: true,
                        });
                      }.bind(this)}
                    />
                  </div>
                  <p style={getStyle(screenSize, styles, 'filterDescription')}>{t('alwaysInvoiceOnMonthEndHelp')}</p>
                </div>

                <CBInputField
                  name="netvisor_product_key_work"
                  inputStyle={inputStyle}
                  value={formData.netvisor_product_key_work}
                  placeholder=""
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('netvisorProductKeyWork')}
                  labelTextStyle={inputLabelStyle}
                />

                <CBInputField
                  name="netvisor_product_key_parts"
                  inputStyle={inputStyle}
                  value={formData.netvisor_product_key_parts}
                  placeholder=""
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('netvisorProductKeyParts')}
                  labelTextStyle={inputLabelStyle}
                />

                <CBInputField
                  name="netvisor_product_key_other"
                  inputStyle={inputStyle}
                  value={formData.netvisor_product_key_other}
                  placeholder=""
                  onChange={this.updateFormState}
                  validators={[]}
                  isValidCallback={function () {}}
                  labelText={t('netvisorProductKeyOther')}
                  labelTextStyle={inputLabelStyle}
                />

                <div style={getStyle(screenSize, styles, 'filterSection')}>
                  <div style={getStyle(screenSize, styles, 'filterHeader')}>
                    <i className="pi pi-filter" style={{ fontSize: 16, color: T.accent }} />
                    <h3 style={getStyle(screenSize, styles, 'filterTitle')}>{t('invoiceFilterTitle')}</h3>
                  </div>
                  <p style={getStyle(screenSize, styles, 'filterDescription')}>{t('invoiceFilterDescription')}</p>

                  <label style={{ ...inputLabelStyle, marginTop: 16, marginBottom: 4 }}>{t('filterRegnrSectionLabel')}</label>
                  <p style={getStyle(screenSize, styles, 'filterHelp')}>{t('filterRegnrHelp')}</p>
                  <div style={getStyle(screenSize, styles, 'checkboxGroup')}>
                    <CBLabelAndCheckbox
                      labelText={t('filterRegnrInOurReference')}
                      checked={formData.filter_regnr_in_our_reference}
                      onChange={function () {
                        this.setState({
                          formData: { ...this.state.formData, filter_regnr_in_our_reference: !this.state.formData.filter_regnr_in_our_reference },
                          hasChanges: true,
                        });
                      }.bind(this)}
                    />
                    <CBLabelAndCheckbox
                      labelText={t('filterRegnrInYourReference')}
                      checked={formData.filter_regnr_in_your_reference}
                      onChange={function () {
                        this.setState({
                          formData: { ...this.state.formData, filter_regnr_in_your_reference: !this.state.formData.filter_regnr_in_your_reference },
                          hasChanges: true,
                        });
                      }.bind(this)}
                    />
                    <CBLabelAndCheckbox
                      labelText={t('filterRegnrInAgreementIdentifier')}
                      checked={formData.filter_regnr_in_agreement_identifier}
                      onChange={function () {
                        this.setState({
                          formData: { ...this.state.formData, filter_regnr_in_agreement_identifier: !this.state.formData.filter_regnr_in_agreement_identifier },
                          hasChanges: true,
                        });
                      }.bind(this)}
                    />
                    <CBLabelAndCheckbox
                      labelText={t('filterRegnrInItemDescriptions')}
                      checked={formData.filter_regnr_in_item_descriptions}
                      onChange={function () {
                        this.setState({
                          formData: { ...this.state.formData, filter_regnr_in_item_descriptions: !this.state.formData.filter_regnr_in_item_descriptions },
                          hasChanges: true,
                        });
                      }.bind(this)}
                    />
                    <CBLabelAndCheckbox
                      labelText={t('filterRegnrInAttachmentFreeText')}
                      checked={formData.filter_regnr_in_attachment_free_text}
                      onChange={function () {
                        this.setState({
                          formData: { ...this.state.formData, filter_regnr_in_attachment_free_text: !this.state.formData.filter_regnr_in_attachment_free_text },
                          hasChanges: true,
                        });
                      }.bind(this)}
                    />
                  </div>

                  <label style={{ ...inputLabelStyle, marginTop: 20, marginBottom: 4 }}>{t('filterRequireSectionLabel')}</label>
                  <p style={getStyle(screenSize, styles, 'filterHelp')}>{t('filterRequireHelp')}</p>
                  <CBInputField
                    name="filter_require_in_our_reference"
                    inputStyle={inputStyle}
                    value={formData.filter_require_in_our_reference}
                    placeholder=""
                    onChange={this.updateFormState}
                    validators={[]}
                    isValidCallback={function () {}}
                    labelText={t('filterRequireInOurReference')}
                    labelTextStyle={inputLabelStyle}
                  />
                  <CBInputField
                    name="filter_require_in_your_reference"
                    inputStyle={inputStyle}
                    value={formData.filter_require_in_your_reference}
                    placeholder=""
                    onChange={this.updateFormState}
                    validators={[]}
                    isValidCallback={function () {}}
                    labelText={t('filterRequireInYourReference')}
                    labelTextStyle={inputLabelStyle}
                  />
                  <CBInputField
                    name="filter_require_in_agreement_identifier"
                    inputStyle={inputStyle}
                    value={formData.filter_require_in_agreement_identifier}
                    placeholder=""
                    onChange={this.updateFormState}
                    validators={[]}
                    isValidCallback={function () {}}
                    labelText={t('filterRequireInAgreementIdentifier')}
                    labelTextStyle={inputLabelStyle}
                  />
                </div>

                <div style={getStyle(screenSize, styles, 'buttonContainer')}>
                  <Button
                    onClick={this.submitForm}
                    label={t('saveChanges')}
                    disabled={isLoading || !hasChanges}
                    style={{
                      backgroundColor: hasChanges ? T.accent : 'rgba(255,255,255,0.1)',
                      border: 'none',
                      color: hasChanges ? '#0077b0' : T.textMuted,
                      fontWeight: 600,
                      opacity: (!hasChanges || isLoading) ? 0.5 : 1,
                    }}
                  />
                </div>
              </div>
            </div>
          );
        }.bind(this)}
      </CBMediaQuery>
    );
  }
}

var styles = {
  default: {
    card: { ...cardStyle, position: 'relative' },
    header: { display: 'flex', alignItems: 'center', gap: 16, marginBottom: 28 },
    iconBox: {
      width: 48, height: 48, borderRadius: 12,
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    },
    title: { color: T.textPrimary, fontSize: 18, fontWeight: 600, margin: 0 },
    description: { color: T.textSecondary, fontSize: 13, margin: '4px 0 0 0' },
    formContainer: { maxWidth: '100%' },
    filterSection: {
      marginTop: 32,
      paddingTop: 24,
      borderTop: '1px solid rgba(255,255,255,0.1)',
    },
    filterHeader: {
      display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4,
    },
    filterTitle: {
      color: T.textPrimary, fontSize: 16, fontWeight: 600, margin: 0,
    },
    filterDescription: {
      color: T.textSecondary, fontSize: 13, margin: '0 0 12px 0',
    },
    filterHelp: {
      color: T.textMuted, fontSize: 12, margin: '0 0 8px 0', fontStyle: 'italic',
    },
    checkboxGroup: {
      display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 4,
    },
    buttonContainer: { marginTop: 28 },
  },
  medium: {
    card: { ...cardStyle, padding: 16 },
  },
};

function mapStateToProps(state) {
  return {
    chainInvoiceSettings: state.chain.chainInvoiceSettings,
    chainInvoiceSettingsStatus: state.chain.chainInvoiceSettingsStatus,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchChainInvoiceSettings: _fetchChainInvoiceSettings,
    updateChainInvoiceSettings: _updateChainInvoiceSettings,
  },
)(translate('ChainSettingsView')(SettingsChainInvoiceV2));
